module.exports = __webpack_public_path__ + "img/about_us5.ab0d7fde.png";